if (!customElements.get('perfection-sticky-purchase')) {
  customElements.define(
    'perfection-sticky-purchase',
    class PerfectionStickyPurchase extends HTMLElement {
      abortController = undefined;
      mainButtonObserver = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.anchor = document.getElementById(this.dataset.anchorId);
        this.mainButton = document.getElementById(this.dataset.mainSubmitId);
        this.price = document.getElementById(this.dataset.priceId);
        this.stickyButton = this.querySelector('[data-sticky-submit]');
        this.stickyLabel = this.querySelector('[data-sticky-label]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.stickyVariant = this.querySelector('[data-sticky-variant]');

        if (!this.anchor) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        window.addEventListener('scroll', this.updateVisibility, { passive: true, signal });
        window.addEventListener('resize', this.updateVisibility, { passive: true, signal });
        this.stickyButton?.addEventListener('click', this.submitMainForm, { signal });

        if (this.mainButton) {
          this.mainButtonObserver = new MutationObserver(() => this.syncButton());
          this.mainButtonObserver.observe(this.mainButton, {
            attributes: true,
            childList: true,
            subtree: true,
          });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.sectionId) return;

            this.dataset.selectedVariant = data.variant?.title || '';
            window.requestAnimationFrame(() => {
              this.syncButton();
              this.syncPrice();
              this.syncVariant();
            });
          });
        }

        this.syncButton();
        this.syncPrice();
        this.syncVariant();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.mainButtonObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      updateVisibility = () => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const purchaseBlockPassed = this.anchor.getBoundingClientRect().bottom < 0;
        const shouldShow = isMobile && purchaseBlockPassed;

        this.classList.toggle('is-visible', shouldShow);
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        this.inert = !shouldShow;
      };

      submitMainForm = () => {
        if (!this.mainButton || this.stickyButton?.disabled) return;
        this.mainButton.click();
      };

      syncButton() {
        if (!this.mainButton || !this.stickyButton || !this.stickyLabel) return;

        const label = this.mainButton.querySelector('span')?.textContent?.trim();
        const disabled =
          this.mainButton.disabled ||
          this.mainButton.getAttribute('aria-disabled') === 'true';

        this.stickyButton.disabled = disabled;
        this.stickyButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        if (label) this.stickyLabel.textContent = label;
      }

      syncPrice() {
        if (!this.price || !this.stickyPrice) return;

        const priceRoot = this.price.querySelector('.price');
        const activePrice = priceRoot?.classList.contains('price--on-sale')
          ? priceRoot.querySelector('.price-item--sale')
          : priceRoot?.querySelector('.price-item--regular');

        if (activePrice?.textContent) {
          this.stickyPrice.textContent = activePrice.textContent.trim();
        }
      }

      syncVariant() {
        if (!this.stickyVariant || !this.dataset.selectedVariant) return;

        const template = this.stickyVariant.textContent;
        const separator = template.indexOf(':');
        const prefix = separator >= 0 ? template.slice(0, separator + 1) : '';
        this.stickyVariant.textContent = `${prefix} ${this.dataset.selectedVariant}`.trim();
      }
    }
  );
}
